import { Navigate } from "react-router-dom";

import { LoginForm } from "@/features/auth/ui/LoginForm";
import { useAuth } from "@/features/auth/state/useAuth";

export const LoginRoute = () => {
    const { isAuthenticated } = useAuth();

    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return <LoginForm />;
};

